import React, { useEffect, useState } from "react";
import HeaderV2 from "../../../BackendV2/Admin/Navs/HeaderV2";
import NavbarV2 from "../NavbarV2/NavbarV2";
import { useSelector, useDispatch } from "react-redux";
import {fetchProjectsByPorteur} from '../../../../redux/projectsByPorteur/ProjectByPorteurAction';
import { NavLink } from "react-router-dom";
import HeaderV2Projet from "../NavProjet/HeaderV2";

const TableauDeBordEntrepreneur = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const ProjectByPorteur = useSelector((state) => state.projectsByPorteur);
  const dispatch = useDispatch();
  const { filteredData } = ProjectByPorteur;
  dispatch(fetchProjectsByPorteur());

  const totalProjects = filteredData ? filteredData.length : 0;

  return (
    <div className="dashboard-container paddingDashboard">
    <HeaderV2Projet />
    <div className="no-view-mobile">
      <NavbarV2 />
    </div>
    <div className="content">
      <div className="section-content-page-tb-investisseur">
        <div className="">
          <div className="row me-2">
              <div className="col-md-4">
              <NavLink to="/entrepreneur/gestion-des-projets" className="dashboard-card">
        <div className="dasboard-card-info">
          <p className="dasboard-card-title">Nombre de projet</p>
          <p className="dasboard-card-montant">{totalProjects}</p>
        </div>
        <div className="dasboard-card-img-container">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.94668 5.31816H19.0092C19.1734 5.31809 19.3375 5.32851 19.5005 5.34937C19.4453 4.96167 19.3121 4.58917 19.109 4.25433C18.9059 3.91949 18.6371 3.62925 18.3188 3.4011C18.0006 3.17294 17.6394 3.01161 17.257 2.92683C16.8747 2.84204 16.4792 2.83556 16.0943 2.90776L4.5292 4.88223H4.51602C3.79007 5.02105 3.14451 5.43178 2.71118 6.03052C3.36403 5.56616 4.14553 5.31713 4.94668 5.31816Z"
              fill="white"
            />
            <path
              d="M19.0093 6.37482H4.94678C4.20111 6.37563 3.48621 6.67221 2.95894 7.19948C2.43167 7.72675 2.13509 8.44164 2.13428 9.18732V17.6248C2.13509 18.3705 2.43167 19.0854 2.95894 19.6127C3.48621 20.1399 4.20111 20.4365 4.94678 20.4373H19.0093C19.7549 20.4365 20.4698 20.1399 20.9971 19.6127C21.5244 19.0854 21.821 18.3705 21.8218 17.6248V9.18732C21.821 8.44164 21.5244 7.72675 20.9971 7.19948C20.4698 6.67221 19.7549 6.37563 19.0093 6.37482ZM16.9219 14.8123C16.6437 14.8123 16.3719 14.7298 16.1406 14.5753C15.9093 14.4208 15.7291 14.2012 15.6227 13.9442C15.5162 13.6873 15.4884 13.4045 15.5426 13.1317C15.5969 12.8589 15.7308 12.6084 15.9275 12.4117C16.1242 12.215 16.3747 12.0811 16.6475 12.0268C16.9203 11.9726 17.2031 12.0004 17.46 12.1069C17.717 12.2133 17.9366 12.3935 18.0911 12.6248C18.2456 12.8561 18.3281 13.1279 18.3281 13.4061C18.3281 13.779 18.18 14.1367 17.9162 14.4004C17.6525 14.6642 17.2948 14.8123 16.9219 14.8123Z"
              fill="white"
            />
            <path
              d="M2.15625 12.1514V7.77881C2.15625 6.82651 2.68359 5.22998 4.51392 4.88413C6.06738 4.59277 7.60547 4.59277 7.60547 4.59277C7.60547 4.59277 8.61621 5.2959 7.78125 5.2959C6.94629 5.2959 6.96826 6.37256 7.78125 6.37256C8.59424 6.37256 7.78125 7.40527 7.78125 7.40527L4.50732 11.1187L2.15625 12.1514Z"
              fill="white"
            />
          </svg>
        </div>
      </NavLink>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default TableauDeBordEntrepreneur;
